<template>
  <b-card
    v-if="data"
    class="card-congratulation-medal"
  >
    <h5>Tebrikler 🎉 {{ userData.firstName }}!</h5>
    <b-card-text class="font-small-3">
      Son bir haftada
    </b-card-text>
    <h3 class="mb-75 mt-2 pt-50">
      <b-link>{{ kFormatter(statics[2].title.split('.')[0].replace(',', '')) }} ₺ değerinde ürün hediye ettin</b-link>
    </h3>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
    >
      Hediyeleri gör
    </b-button>
    <b-img
      :src="require('@/assets/images/illustration/badge.svg')"
      class="congratulation-medal"
      alt="Medal Pic"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    statics: {
      type: Object,
      default: () => {},
    },
  },
  computed:{
    userData() {
      return JSON.parse(localStorage.getItem('userData'))
    }
  },
  methods: {
    kFormatter,
  },
}
</script>
